import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import useEavierAuthTheme from '@/hooks/use-eavier-auth-theme';
import usePlatform from '@/hooks/use-platform';
import LogtoSignature from '@/shared/components/LogtoSignature';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { experienceSettings, theme } = useContext(PageContext);
  const { isMobile } = usePlatform();
  const isEavierAuthTheme = useEavierAuthTheme();
  const hideLogtoBranding = experienceSettings?.hideLogtoBranding === true;

  return (
    <div className={classNames(styles.viewBox, isEavierAuthTheme && styles.eavierAuthViewBox)}>
      <div
        className={classNames(
          styles.container,
          layoutClassNames.pageContainer,
          isEavierAuthTheme && styles.eavierAuthContainer
        )}
      >
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        <main
          className={classNames(
            styles.main,
            layoutClassNames.mainContent,
            isEavierAuthTheme && styles.eavierAuthMain
          )}
        >
          <Outlet />
          {!hideLogtoBranding && !isEavierAuthTheme && (
            <LogtoSignature
              className={classNames(styles.signature, layoutClassNames.signature)}
              theme={theme}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
